import React, { PropsWithChildren } from 'react'
import './index.scss'

interface CatalogTransferWizardHeaderProps {
    title: string
    subtitle?: string
}

const CatalogTransferWizardHeader = ({
    title,
    subtitle,
    children,
}: PropsWithChildren<CatalogTransferWizardHeaderProps>) => (
    <section className="ct-wizard-section-header">
        <h3>{title}</h3>
        {subtitle && <h5>{subtitle}</h5>}
        {children}
    </section>
)

export default CatalogTransferWizardHeader
